
























import {Component, Prop, Vue} from 'vue-property-decorator';
import {State, Getter, Action, Mutation} from 'vuex-class';

@Component
export default class Video extends Vue {
  @Prop()
  private videoData!: any;
  private isPosterImage: boolean = true;
  private isPause: boolean = false;

  private palyVideo() {
    const partVideo: any = this.$refs.partVideo;
    if (partVideo.paused) {
      this.isPause = true;
      this.isPosterImage = false;
      partVideo.play();
    } else {
      this.isPause = false;
      partVideo.pause();
    }

  }

  private videoEnd() {
    const partVideo: any = this.$refs.partVideo;
    partVideo.onended = () => {
      this.isPosterImage = true;
      this.isPause = false;
    };
  }


  private mounted() {
    this.videoEnd();
  }
}

